<template>
    <div>
        <v-layout wrap>
            <v-flex xs12>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        Visualisation of path before and after anomaly 
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                        <v-btn @click="showAll=!showAll" v-if="showAll" dark fab small color="blue"><h2> - </h2></v-btn>
                        <v-btn @click="showAll=!showAll" v-if="!showAll" dark fab small color="blue"><h2> + </h2></v-btn>
                    </v-flex>
                        <info>
                            <template slot>
                               Path change
                            </template>
                            <template slot="body">
                                <p>Path data from each Peer ASN before and after an anomaly.</p>
                                
                                <p>Different colours illustrate different properties of that ASN: </p>
                                <ul>
                                    <li> Yellow - Origin ASN </li>
                                    <li> Blue - Transit ASN </li>
                                    <li> Green - Peer ASN </li>
                                    <li> Red - Any ASN which does not appear in the initial network diagram. </li>
                                </ul>

                                <p> Select an ASN to bring up more information regarding that ASN</p>
                            </template>
                            <!-- <template slot="action">
                                <v-btn flat color="primary" to="/ASNBaseline"> MORE ASN INFO</v-btn>
                            </template> !-->
                        </info>
                </v-toolbar>
                <v-card id="id" key="id" v-if="showAll">
                    <v-container grid-list-xl>
                        <v-layout align-center justify-center wrap>
                            <v-flex v-bind:class="size" v-if="showBeforePath">
                                <v-card>
                                    <v-toolbar color="accent">
                                        <v-toolbar-title :style="$store.state.textFormatting.headers">
                                            Before anomaly
                                        </v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-flex justify-center align-center class="text-xs-center">
                                            <div class="nodeedge">
                                                <d3-network  ref='net' :net-nodes="beforeAnom.nodes" :net-links="beforeAnom.links" :options="options"
                                                @node-click="nodeClickHandler"></d3-network>
                                            </div>
                                        </v-flex>
                                    </v-card-text>
                                </v-card>
                            </v-flex>

                            <v-flex v-if="!showBeforePath" align-center>
                                <v-layout>
                                    <v-flex xs6>
                                        <v-card color="green">
                                            <v-card-text class="text-xs-center"> <h2 :style="$store.state.textFormatting.main"> PEER ASN </h2> </v-card-text>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-card color="blue">
                                            <v-card-text class="text-xs-center"> <h2 :style="$store.state.textFormatting.main"> TRANSIT ASN </h2> </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs6>
                                        <v-card color="red">
                                            <v-card-text class="text-xs-center"> <h2 :style="$store.state.textFormatting.main"> NEW ASN </h2> </v-card-text>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-card>
                                            <v-container fill-height fluid class="pa-0" child-flex justify-center align-center>    
                                                <v-flex xs6 fluid pa-0 ma-0 align-center>
                                                    <v-card flat tile color="yellow">
                                                        <v-card-text class="text-xs-center pa-0"> <h3 :style="$store.state.textFormatting.main"> OBSERVED </h3> <h2 :style="$store.state.textFormatting.main">ORIGIN </h2> </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs6 fluid pa-0>
                                                    <v-card flat tile color="black">
                                                        <v-card-text class="text-xs-center white--text pa-0"> <h3 :style="$store.state.textFormatting.main"> NEW </h3> <h2 :style="$store.state.textFormatting.main"> ORIGIN </h2> </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-container>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <v-flex v-bind:class="size" v-if="showAfterPath">
                                <v-card>
                                    <v-toolbar color="accent">
                                        <v-toolbar-title :style="$store.state.textFormatting.headers">
                                             After anomaly
                                        </v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-flex justify-center align-center class="text-xs-center">
                                            <div class="nodeedge">
                                                <d3-network  :net-nodes="afterAnom.nodes" :net-links="afterAnom.links" :options="options"
                                                @node-click="nodeClickHandler" ></d3-network>
                                            </div>
                                        </v-flex>
                                    </v-card-text>
                                </v-card>
                            </v-flex>

                            <v-layout v-if="showBeforePath" align-center>
                                <v-flex xs3>
                                    <v-card color="green">
                                        <v-card-text class="text-xs-center"> <h2 :style="$store.state.textFormatting.main"> PEER ASN </h2> </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs3>
                                    <v-card color="blue">
                                        <v-card-text class="text-xs-center"> <h2 :style="$store.state.textFormatting.main"> TRANSIT ASN </h2> </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs3>
                                    <v-card color="red">
                                        <v-card-text class="text-xs-center"> <h2 :style="$store.state.textFormatting.main"> NEW ASN </h2> </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs3>
                                    <v-card>
                                        <v-container fill-height fluid class="pa-0" child-flex justify-center align-center>    
                                            <v-flex xs6 fluid pa-0 ma-0 align-center>
                                                <v-card flat tile color="yellow">
                                                    <v-card-text class="text-xs-center pa-0"> <h3 :style="$store.state.textFormatting.main"> OBSERVED </h3> <h2 :style="$store.state.textFormatting.main">ORIGIN </h2> </v-card-text>
                                                </v-card>
                                            </v-flex>
                                            <v-flex xs6 fluid pa-0>
                                                <v-card flat tile color="black">
                                                    <v-card-text class="text-xs-center white--text pa-0"> <h3 :style="$store.state.textFormatting.main"> NEW </h3> <h2 :style="$store.state.textFormatting.main"> ORIGIN </h2> </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </v-container>
                                    </v-card>
                                </v-flex>
                            </v-layout>

                            <v-flex v-if="!showAfterPath" :style="$store.state.textFormatting.main">
                                {{message}}
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-layout>
                        <v-flex xs12 v-if="currentASN">
                            <v-card>
                                <v-card-text>
                                    <v-toolbar dark flat color="secondary" height="96px">
                                        <v-toolbar-title :style="$store.state.textFormatting.headers">
                                        Selected ASN: {{currentASN}}; <br> <font :style="$store.state.textFormatting.main"> {{ asnorg }} </font> <v-progress-circular v-if="loading" icon indeterminate color="blue" ></v-progress-circular>
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <info>
                                            <template>
                                                List of ASN Prefixes
                                            </template>
                                            <template slot="body">
                                                <p>A list of prefixes which have been registered with the ASN as per information gathered by
                                                Internet Routing Registries.
                                                </p>
                                                <br>
                                                <p> The country breakdown gives the percentage of IP addresses under the prefix which reside in each country where 0% appears for &lt;0.01%   </p>
                                            </template>
                                        </info>
                                    </v-toolbar>
                                </v-card-text>
                                <template v-if="!loading2"> 
                                    <v-data-table dense :headers="headersPrefixLocation" :items="ASNEnirchData" v-if="ASNEnirchData">
                                        <template slot="headerCell" slot-scope="props">
                                            <v-tooltip top eager>
                                            <span slot="activator" :style="$store.state.textFormatting.main" class="text-xs-center">
                                                {{ props.header.text }}
                                            </span>
                                            <span :style="$store.state.textFormatting.main">
                                                {{ props.header.ad_text }}
                                            </span>
                                            </v-tooltip>
                                        </template>
                                        <template slot="items" slot-scope="props">
                                            <tr>
                                                <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.prefix }}</td>
                                                <!-- <td class="text-xl-center"> {{ props.item.organisation }}</td> -->
                                                <td class="text-xs-center" :style="$store.state.textFormatting.main"> {{ props.item.country }}</td>
                                            </tr>
                                        </template>
                                        <template slot="no-data">
                                            <v-alert :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main">
                                            No prefixes found
                                            </v-alert>
                                        </template>
                                    </v-data-table>
                                    <!-- <v-btn color="success" @click="next100Prefs()" :disabled="next100disabled"> Next 500 prefixes </v-btn>
                                    <v-flex>
                                        <h6> currently showing {{ lowpre }}-{{ highpre }} of {{ totalpre }} prefixes </h6>
                                    </v-flex> !-->
                                </template>
                                <v-flex>
                                    <v-progress-circular v-if="loading2" indeterminate color="purple"></v-progress-circular>
                                </v-flex>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex v-if="currentASN" xs12> 
                            <asnbaseline :asn="currentASN" :key="id"> </asnbaseline>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { API, graphqlOperation} from 'aws-amplify'
import { countryNames } from '../operational/countrynames.js'
import D3Network from 'vue-d3-network'
import info from '../operational/infopopout.vue'
import asnbaseline from './asn-baseline.vue'

export default {
    name: 'asn-path-change',
    components: {
        D3Network,
        info,
        asnbaseline
    },
    props: {
        pathDataBefore: Array,
        pathDataAfter: Array
    },
    data () {
    return {
        id: 0,
        ASNEnirchData: [],
        headersPrefixLocation: [
                { text: 'Prefix', value:'prefix', sortable: false, align:'left'},
                // { text: 'Organisation', value:'organisation', sortable: false, align:'centre'},
                { text: 'Country', value:'country', sortable: false, align:'centre'}
                ],
        showBeforePath: true,
        selectedASN: [],
        combinedTestData: [],
        allPathData: [this.pathDataBefore, this.pathDataAfter],
        showAfterPath: true,
        message: '',
        size: "xs12 md8 xl6",
        currentASN: false,
        showMenu: true,
        loading: false,
        selected: {},
        loading2:false,
        asnorg: false,
        lowpre: 0,
        highpre: 500,
        totalpre: 0,
        next100disabled: false,
        prefixrotation: 1,
        ownerData: [],
        showSelection: true,
        linksSelected: {},
        beforeAnom: [],
        afterAnom: [],
        nodes: [],
        links: [],
        options: {
            force: 1492,
            //size:{ w:400, h:400},
            nodeSize: 10,
            nodeLabels: true,
            linkLabels:false,
            canvas: false,
            fontSize: this.$store.state.textFormatting.traceroute.fontSize,
            responsive: true
            //forces: {centre: false, X: 0, Y: 2, Link: true}
        },
        beforeaftertable: false,
        showAll: true
    }

    },
    beforeMount () {
        this.afterAnom = this.initiatePathChangeVisualtion(this.pathDataAfter)
        this.beforeAnom = this.initiatePathChangeVisualtion(this.pathDataBefore)

        //this.compareNodes(this.beforeAnom, this.afterAnom)
    },
    mounted () {
        this.compareNodes(this.beforeAnom, this.afterAnom)
    },
    methods: {
        compareNodes: function (beforeAnom, afterAnom) { 
            var newNodesInPath = [];
//            console.log(beforeAnom)
//            console.log(afterAnom)
            if (beforeAnom.nodes.length == 0) {
                this.showBeforePath = false;
            } else {
                for (var j = 0; j < afterAnom.nodes.length; j = j +1) {
                    if ( j< beforeAnom.nodes.length ) {
                        if (beforeAnom.nodes[j].asnraw == "N/A" || beforeAnom.nodes[j].asnraw == "empty" || !beforeAnom.nodes[j].asnraw) {
                            newNodesInPath.push(afterAnom.nodes[j])
                            this.showBeforePath = false;
                        } else {
                            if (!this.contains(beforeAnom.nodes, "asnraw", afterAnom.nodes[j].asnraw)) {
                                if (afterAnom.nodes[j]._color == "gold") {
                                    afterAnom.nodes[j]._color = "black"
                                    newNodesInPath.push(afterAnom.nodes[j])
                                } else if (afterAnom.nodes[j]._color == "green") { 
                                    afterAnom.nodes[j]._color = "red"
                                        newNodesInPath.push(afterAnom.nodes[j]) 
                                } else {
                                    afterAnom.nodes[j]._color = "red"
                                    newNodesInPath.push(afterAnom.nodes[j])
                                }
                            } else {
                                newNodesInPath.push(afterAnom.nodes[j])
                            }
                        }
                    } else {
                        newNodesInPath.push(afterAnom.nodes[j])
                    }
                }
            }
            this.afterAnom.nodes = newNodesInPath
        },
        getASNOwn: async function () {
            this.asnorg = null;
            this.totalpre = 0;
            var asn = this.currentASN;
            try {
                var qry = `query getASNOwner { getASNOwner ( asn: "` + asn + `" ) {
                        organisation
                    }
                }`;
                console.log(qry)
                    
                const ASNOwnData = await API.graphql(graphqlOperation(qry));
                if (ASNOwnData.data.getASNOwner) {
                    var ownData = ASNOwnData.data.getASNOwner;

                    console.log(ownData);
                    if (ownData.length > 0) {
                        this.ownerData = ownData;
                        this.asnorg = ownData[0].organisation;
                        //this.totalpre = ownData[0].totalprefs;
                        /*var i;
                        for( i = 0; i < ownData.length; i++) {
                            this.totalpre = this.totalpre + ownData[i].totalprefs;

                        }*/
                    } else {
                        this.ownerData = [];
                        this.asnorg = "Unknown";
                    }
                }
            } catch (err) {
                console.log(err);
                this.ownerData = [];
                this.asnorg = "Unknown";
            }



        },
        initiatePathChangeVisualtion: function (beforeAnomaly) {
        //    console.log(beforeAnomaly)
            var refinedNodes = [];
            var NodesAndEdges = {"nodes": [], "links": []};
            try {
                if (typeof beforeAnomaly !== 'undefined' && beforeAnomaly) {
                    for (var i = 0; i< beforeAnomaly.length; i++) {
                        var j = 0;
                        refinedNodes.push([]);
                        for (var n = 0; n<beforeAnomaly[i].length; n++) {
                            if (n == 0) {
                                refinedNodes[i].push(beforeAnomaly[i][n]);
                            } else {
                                if (refinedNodes[i][j] != beforeAnomaly[i][n]) {
                                    refinedNodes[i].push(beforeAnomaly[i][n]);
                                    j++;
                                }
                            }
                        }
                    }
//                    console.log("REFINED NODES");
//                    console.log(refinedNodes);

                    var nodes = [];
                    var links = [];
                    var nodeID = 0;
                    for (var i = 0; i< refinedNodes.length; i=i+1) {
                        for (var n = 0; n<refinedNodes[i].length; n=n+1) {
                            if (!this.contains(nodes, "asnraw", refinedNodes[i][n])) {
                                var color;
                                if (n==0) {
                                    color = "green"
                                } else if (n==refinedNodes[i].length-1) {
                                    color = "gold"
                                } else {
                                    color = "blue"
                                }
                                var node = 
                                {
                                    id: nodeID,
                                    name: 'AS' + refinedNodes[i][n],
                                    asnraw: refinedNodes[i][n], 
                                    _color: color
                                }
                                nodes.push(node)
                                nodeID=nodeID+1
                            }
                        }
                        var edgesForNodes = this.edgesForNodes(refinedNodes[i], nodes)
                        // console.log(nodes[1]["id"])
                        // console.log(edgesForNodes)
                        for (var p = 0; p< edgesForNodes.length; p = p+1) {
                            links.push(edgesForNodes[p])
                        }
                        
                        
                    }
                    NodesAndEdges = {"nodes": nodes, "links": links}
                    if (nodes.length > 20) {
                        this.options.size = { w:750, h:600}
                        this.options.force = 500
                        this.size = "xs12"
                        this.id = this.id+1
                    }
                }
                return NodesAndEdges
            } catch (err) {
                console.log(err)
            }
            

        },
        edgesForNodes: function (rawList, knownNodes) {

            var edgesForNodes = []

            for (var i = 0; i < rawList.length; i =i+1) {
                var currentASN = rawList[i]
                var nextASN = rawList[i+1]
                for (var n = 0; n < knownNodes.length; n=n+1)  {
                    if (knownNodes[n]["asnraw"] == currentASN)  {
                        for (var k = 0; k < knownNodes.length; k =k+1)  {
                            if (knownNodes[k]["asnraw"] == nextASN)  {
                                var edgeTemp =  { sid: knownNodes[n]["id"], tid: knownNodes[k]["id"] }
                                edgesForNodes.push(edgeTemp)
                            }
                        }      
                    }
                }
            }
            return edgesForNodes
 
        },
        contains: function (arr, key, val) {
            for (var i = 0; i < arr.length; i++) {
                if(arr[i][key] === val) return true;
            }
            return false;
        },
        next100Prefs: async function () {
            if(this.totalpre > this.highpre) {
                this.getPrefixInfo(this.currentASN, this.prefixrotation);
                this.prefixrotation = this.prefixrotation + 1;
            } else {
                this.next100disabled = true;
            }
        },
        getPrefixInfo: async function(asn, rotation) {
            this.loading2 = true;
            this.lowpre = rotation * 500;
            this.highpre = rotation * 500 + 500;
            this.ASNEnirchData = null;
        
            try {
                if(rotation == 0) {
                    var getASNEnrichmentData = `query getASNEnrich {
                                                    getASNEnrich(asn: "`+asn+`", page_offset:0, page_rows:10000) {
                                                        asn
                                                        prefix
                                                        country
                                                        
                                                    }
                    }`
                } else {
                    var getASNEnrichmentData = `query getASNEnrich {
                                                    getASNEnrich(asn: "`+asn+`", page_offset:` + 500 * rotation + `, page_rows:500) {
                                                        asn
                                                        prefix
                                                        country
                                                        
                                                    }
                    }`
                }
                console.log(getASNEnrichmentData)
                
                const ASNEnrichmentData = await API.graphql(graphqlOperation(getASNEnrichmentData));
                var ASNEnrichmentdataUnwraped = ASNEnrichmentData.data.getASNEnrich

                console.log(ASNEnrichmentdataUnwraped)
                //this.totalpre = ASNEnrichmentdataUnwraped.length;
                var prefs = [];
                
                for(var count=0; count<ASNEnrichmentdataUnwraped.length; count=count+1){
                    if (ASNEnrichmentdataUnwraped[count].country == null) {
                        ASNEnrichmentdataUnwraped[count].country = "Unknown"
                    } else {
                         ASNEnrichmentdataUnwraped[count].country = this.sortPrefixCountry(JSON.parse(ASNEnrichmentdataUnwraped[count].country))
                    }
                    if (!prefs.includes(ASNEnrichmentdataUnwraped[count].prefix)) {
                        prefs.push(ASNEnrichmentdataUnwraped[count].prefix)
                    }
                }
                this.totalpre = prefs.length;
                if (ASNEnrichmentdataUnwraped.length ==0) {
                    this.message="No information for this ASN"
                    this.showInfo = false
                    this.ASNEnirchData = null
                } else {
                    this.ASNEnirchData = ASNEnrichmentdataUnwraped;
                    this.showInfo = true;
                    this.message='';
                }
                this.loading2 = false;
            } catch(err) {
                
                this.message=err.message
                this.loading2 = false;
            }
        },
        nodeClickHandler: async function (event,node) {
            // console.log(event) ;
            // console.log(node);
            // this.$emit('node-click', event)
            // var selectedASN = event.path[0].attributes[3].nodeValue.split("AS")[1]
            var selectedASN = node.asnraw;
            this.message = '';
            this.currentASN = selectedASN;
            this.lowpre = 0;
            this.highpre = 500;
            this.getASNOwn();
            this.ASNEnirchData = [];
            this.next100disabled = false;
            try {
                this.loading = true;
                this.lowpre = 0;
                this.highpre = 500;
                this.getASNOwn();
                this.ASNEnirchData = [];
                this.next100disabled = false;
                var getASNEnrichmentData = `query getASNEnrich {
                                                getASNEnrich(asn: "`+selectedASN+`", page_offset:0, page_rows:500) {
                                                    asn
                                                    prefix
                                                    country
                                                    
                                                }
                                            }`
                                            
               

                const ASNEnrichmentData = await API.graphql(graphqlOperation(getASNEnrichmentData));
                var ASNEnrichmentdataUnwraped = ASNEnrichmentData.data.getASNEnrich
                for(var count=0; count<ASNEnrichmentdataUnwraped.length; count=count+1){
                    if (ASNEnrichmentdataUnwraped[count].country == null) {
                        ASNEnrichmentdataUnwraped[count].country = "Unknown"
                    } else {
                         ASNEnrichmentdataUnwraped[count].country = this.sortPrefixCountry(JSON.parse(ASNEnrichmentdataUnwraped[count].country))
                    }
                }

                if (ASNEnrichmentdataUnwraped.length ==0) {
                    this.message="No information for this ASN";
                    this.showInfo = false;
                    this.loading = false;
                    this.ASNEnirchData = null;
                    this.id= this.id+1;
                } else {
                    this.ASNEnirchData = ASNEnrichmentdataUnwraped;
                    this.loading=false;
                    this.showInfo = true;
                    this.message='';
                    this.id= this.id+1;
                }
            } catch(err) {
                this.loading = true;
                this.message=err.message
            }

            
        },
        initiatePathChangeVisualtionCombinedTest: function (alldata) {

            var combinedTestData = [[],[]];
            
            for (var a = 0; a<alldata.length; a = a+1) {

            var path = alldata[a]
            var nodes = [];
            var links = [];
            var nodeID = 0;
                for (var i = 0; i< path.length; i=i+1) {
                    for (var n = 0; n<path[i].length; n=n+1) {
                        if (!this.contains(nodes, "asnraw", path[i][n])) {
                            var color;
                            if (n==0) {
                                color = "green"
                            } else if (n==path[i].length-1) {
                                color = "gold"
                            } else {
                                color = "blue"
                            }
                            var node = 
                            {
                                id: nodeID,
                                name: 'AS' + path[i][n],
                                asnraw: path[i][n], 
                                _color: color
                            }
                            nodes.push(node)
                            nodeID=nodeID+1
                        }
                    }
                    var edgesForNodes = this.edgesForNodes(path[i], nodes)
                    
                    for (var p = 0; p< edgesForNodes.length; p = p+1) {
                        links.push(edgesForNodes[p])
                    }
                    
                    
                }
            var NodesAndEdges = {"nodes": nodes, "links": links}
            combinedTestData[a].push(NodesAndEdges)
            }
            
            if (nodes.length > 50) {
                this.options.size = { w:750, h:600}
                this.options.force = 500
                this.size = "xs12"
                this.id = this.id+1
                
            }

            
            
            return combinedTestData;
            

        },
        sortPrefixCountry: function (countryJSON) {
            
            var keys = Object.keys(countryJSON)
            var countryString = ""
            for (var i =0; i< keys.length; i = i+1) {
                countryString = countryString + countryNames[keys[i]] + ": " + countryJSON[keys[i]] + "%"
                if (i !== keys.length && keys.length > 1) {
                    countryString= countryString + ", "
                }
            }
            return countryString;
            
        }
    }
}
</script>


<style src="vue-d3-network/dist/vue-d3-network.css">

</style>

<style scoped>

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

</style>